import { clearItems, loadItems, baseUrl } from './archive/ajax-load'

$(function () {
	$('.archive-filter__change').change(function () {
		updateFilters();
		$(this).parent('label').find('span').text($(this).find('option:selected').text());
	});
	$('.archive-filter__clicker').click(function (e) {
		e.preventDefault();
		console.log('click')
		$('.archive-filter__clicker').not(this).removeClass('current border-white').addClass('border-transparent')
		$(this).removeClass('border-transparent').addClass('current border-white')
		updateFilters();
	})
});

function updateFilters () {
	let filters = {};
	$('.archive-filter__clicker.current').each(function () {
		if ($(this).attr('data-value')) {
			filters[$(this).attr('data-name')] = $(this).attr('data-value');
		}
	});
	$('.archive-filter__change').each(function () {
		if ($(this).val()) {
			filters[$(this).attr('name')] = $(this).val();
		}
	});
	let url = baseUrl();
	if (Object.keys(filters).length) {
		url = url + '?' + $.param(filters);
	}

	console.log(url)

	// If parameter is added - this element is also updated updated on ajax
	let clear = '.archive__items';

	$('.archive__loader').show();
	clearItems(clear)
	loadItems(url, '.archive__items').finally(() => {
		$('.archive__loader').hide()
	})
}
